import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';

import { Brand, Unsubscribe } from 'src/app/core';
import { brand } from 'src/app/core/store/brands/brands.selectors';

@Directive({
  selector: '[appBrandAccessCtrl]',
})
export class BrandAccessCtrlDirective extends Unsubscribe {
  brands: string[];
  @Input() set appBrandAccessCtrl(brands: string[]) {
    this.brands = brands;
  }
  constructor(
    private store: Store,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {
    super();
  }

  ngOnInit() {
    this.getBrandState();
  }

  private getBrandState() {
    this.store
      .pipe(
        select(brand),
        take(1),
      )
      .subscribe((brand: Brand) => {
        if (
          typeof this.brands !== 'undefined' &&
          this.brands.find((brandName) => brandName === brand.displayName)
        ) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      });
  }
}
